export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/panels.4ae1200.svg";